import React from 'react';
import PropTypes from 'prop-types';
import { CSVLink } from 'react-csv';
import { FormattedMessage } from 'react-intl';
import messages from '../../../text/messages';

import './csvButton.css';

class CsvButton extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    render() {
        const { data, text, filename } = this.props;
        if (!data) return null;

        const buttonText = text || <FormattedMessage {...messages.download} />;

        return (
            <CSVLink data={data} filename={`${filename || 'data'}.csv`} className="csv-action-button" target="_blank">
                {buttonText}
            </CSVLink>
        );
    }
}

CsvButton.defaultProps = {
    text: undefined,
    filename: undefined,
    data: undefined
};
CsvButton.propTypes = {
    text: PropTypes.any,
    filename: PropTypes.string,
    data: PropTypes.any
};

export default CsvButton;



// WEBPACK FOOTER //
// ./src/components/richButtons/csvButton/index.jsx